import type { FC } from 'react';
import React from 'react';
import { FontStyrene } from '@alfa-bank/site-font-styrene';

import type { IPentagramTotalScore } from './models';
import styles from './styles.css';
export const TotalScore: FC<IPentagramTotalScore> = ({ totalScore }) => {
    return (
        <FontStyrene>
            <text className={styles.totalScore} x="0" y="10">
                {totalScore}
            </text>
        </FontStyrene>
    );
};
